export default __webpack_public_path__ + "static/media/IconoIntegracion.6ef912d5.svg";